/**
 * Functional programming utilities - native JavaScript implementations
 * to replace Ramda dependencies and keep the embed bundle small
 */

export const always = (val) => () => val;
export const isNil = (val) => val === null || val === undefined;
export const when = (pred, fn) => (val) => pred(val) ? fn(val) : val;
export const clamp = (min, max, val) => Math.min(max, Math.max(min, val));
export const includes = (val, arr) => arr.includes(val);
